
import React from "react";
import PageHeader from "../../components/PageHeader";
import CmsUpdateComponent from "../../components/CmsPages/CmsUpdate";

class CmsUpdate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="CMS Update"
                            Breadcrumb={[
                                { name: "CMS", navigate: "/cms-pages" },
                                { name: "CMS Update", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <CmsUpdateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CmsUpdate;
